module.exports = __webpack_public_path__ + "static/media/frozen3.aae61cb3.png";